export default "__VITE_ASSET__DCD$Nms$__"